import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { useStore } from '../../store';
import Sidebar from './Sidebar';

const MobileSidebar: React.FC = () => {
  const sidebarOpen   = useStore(s => s.sidebarOpen);
  const toggleSidebar = useStore(s => s.toggleSidebar);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') toggleSidebar(); };
    if (sidebarOpen) document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [sidebarOpen, toggleSidebar]);

  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [sidebarOpen]);

  // Only render as overlay on mobile
  return (
    <>
      <style>{`@media(min-width:769px){.mobile-drawer-backdrop,.mobile-drawer{display:none!important;}}`}</style>
      {sidebarOpen && (
        <>
          <div className="mobile-drawer-backdrop" onClick={toggleSidebar} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', zIndex:200, backdropFilter:'blur(2px)' }}/>
          <div className="mobile-drawer" style={{ position:'fixed', top:0, left:0, bottom:0, width:260, zIndex:201, animation:'slideIn .22s ease', boxShadow:'4px 0 24px rgba(0,0,0,0.12)' }}>
            <button onClick={toggleSidebar} style={{ position:'absolute', top:14, right:-40, width:32, height:32, borderRadius:'50%', background:'rgba(255,255,255,0.15)', border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'white', zIndex:202 }}>
              <X size={16}/>
            </button>
            <Sidebar/>
          </div>
          <style>{`@keyframes slideIn{from{transform:translateX(-100%)}to{transform:translateX(0)}}`}</style>
        </>
      )}
    </>
  );
};

export default MobileSidebar;
